import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Shared */
import { STATES, TYPES } from "./shared"

Modal.setAppElement("#root")


/* The filter the page opens on — every audience, sent and unsent alike */
export const INITIAL_FILTER = { type: "all", state: "all" }


/* HOW MANY VALUES of the filter differ from the empty one — the button of the page shows it */
export const filterCount = filter => {

    let count = 0

    if (`${filter.type}` !== "all") {
        count = count + 1
    }

    if (`${filter.state}` !== "all") {
        count = count + 1
    }

    return count
}


/* Widget Filter Modal — the audience and the state of the templates. It is opened by the
   reference: this._filter.current.open(filter) */
class FilterModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            filter: { ...INITIAL_FILTER }
        }
    }

    open = filter => {
        this.setState({ visible: true, filter: filter ? { ...filter } : { ...INITIAL_FILTER } })
    }

    close = () => {
        this.setState({ visible: false })
    }

    set = (key, value) => {
        this.setState(previous => ({ filter: { ...previous.filter, [key]: value } }))
    }

    reset = () => {
        this.setState({ filter: { ...INITIAL_FILTER } }, () => this.apply())
    }

    apply = () => {

        const { onApply } = this.props

        this.close()

        if (onApply) {
            onApply({ ...this.state.filter })
        }
    }

    render = () => {

        /* Fields */
        const { visible, filter } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="filter-modal"
                overlayClassName="filter-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="filter-modal-header">
                    <h2>Фильтры уведомлений</h2>
                    <div onClick={this.close} className="filter-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="filter-modal-body">

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Получатели</div>

                        <div className="filter-modal-chips">

                            <div onClick={() => this.set("type", "all")} className={`filter-modal-chip ${`${filter.type}` === "all" ? "active" : ""}`}>Все</div>

                            {TYPES.map(item =>
                                <div
                                    key={item.key}
                                    onClick={() => this.set("type", item.key)}
                                    className={`filter-modal-chip ${`${filter.type}` === item.key ? "active" : ""}`}
                                >
                                    {item.text}
                                </div>
                            )}

                        </div>

                    </div>

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Состояние</div>

                        <div className="filter-modal-chips">

                            <div onClick={() => this.set("state", "all")} className={`filter-modal-chip ${`${filter.state}` === "all" ? "active" : ""}`}>Все</div>

                            {STATES.map(item =>
                                <div
                                    key={`${item.key}`}
                                    onClick={() => this.set("state", item.key)}
                                    className={`filter-modal-chip ${`${filter.state}` === `${item.key}` ? "active" : ""}`}
                                >
                                    {item.text}
                                </div>
                            )}

                        </div>

                    </div>

                </div>

                <div className="filter-modal-footer">
                    <div onClick={this.reset} className="filter-modal-button light">Сбросить</div>
                    <div onClick={this.apply} className="filter-modal-button">Показать</div>
                </div>

            </Modal>
        )
    }
}

export default FilterModal
